export default "//file.bilionpass.com/japandx-web/0.0.1/static/SmileySans-Oblique.b447d7e7-992f79.ttf";